import Text from 'components/ui/Text';
import { formatPrice } from 'utils/formatPrice';

type CreditAmountCellProps = {
    creditAmount: number;
    canEdit?: boolean;
    currency?: string | null;
};

const CreditAmountCell = ({ creditAmount, canEdit, currency }: CreditAmountCellProps) => {
    return (
        <Text fontSize={13} bold={creditAmount > 0} color={canEdit ? 'text' : 'textDisabled'}>
            {creditAmount > 0 ? formatPrice(creditAmount, currency) : '-'}
        </Text>
    );
};

export default CreditAmountCell;
